import"./FeaturedListItem.css.ts.vanilla.css";var t={featuredListItem:"FeaturedListItem_styles_featuredListItem__14hsmzb0",body:"FeaturedListItem_styles_body__14hsmzb1",subText:"FeaturedListItem_styles_subText__14hsmzb2"};export{t as styles};
//# sourceMappingURL=FeaturedListItem.css.vanilla.js.map
